module.exports = __webpack_public_path__ + "media/images/soar/Plameet1-8bea9ff7d09676053c552d44a5753bd5.png";